import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { useThemeStore, THEME_VARS } from "./hooks/useTheme";
import { useAuthStore } from "./stores/authStore";
import Login       from "./screens/Login";
import Shell       from "./components/Shell";
import Dashboard   from "./screens/Dashboard";
import Families    from "./screens/Families";
import FamilyDetail from "./screens/FamilyDetail";
import Backup      from "./screens/Backup";
import Metrics     from "./screens/Metrics";
import AuditLog    from "./screens/AuditLog";
import Team        from "./screens/Team";
import Permissions from "./screens/Permissions";
import Settings    from "./screens/Settings";

function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useThemeStore();
  useEffect(() => {
    const vars = THEME_VARS[theme];
    Object.entries(vars).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
  }, [theme]);
  return <>{children}</>;
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { token } = useAuthStore();
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RequireAuth><Shell /></RequireAuth>}>
            <Route index element={<Dashboard />} />
            <Route path="families" element={<Families />} />
            <Route path="families/:familyId" element={<FamilyDetail />} />
            <Route path="backup" element={<Backup />} />
            <Route path="metrics" element={<Metrics />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="team" element={<Team />} />
            <Route path="permissions" element={<Permissions />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
